module.exports = __webpack_public_path__ + "static/img/Heath.Hocking.b30711d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Heath.Hocking.jpg
// module id = zkTi
// module chunks = 0